<template>
    <v-card class="py-0 my-0" color="transparent" v-if="canedit">
        <v-card-title class='py-0 my-0'>
            <!--<code></code>-->
            <v-layout row>
                <v-flex xs2 v-if="colvis">                    
                    <small>Gewicht 1 Portion </small></br>
                    <keep-alive>
                    <v-text-field                
                        v-model="oneperson"
                        append-icon="search"
                        label="Gewicht"
                        single-line                        
                        solo                
                    ></v-text-field>
                    </keep-alive>
                </v-flex>
                <v-flex xs2 v-if="colvis">
                    <small>Anzahl Zielportionen </small></br>
                    <v-text-field                
                        v-model="targetamount"
                        append-icon="search"
                        label="Personen"
                        single-line
                        hide-details
                        solo                
                    ></v-text-field>
                </v-flex>
            <v-spacer></v-spacer>
            <v-btn
                fab                
                small
                v-on:click="colvis = !colvis"
                >
                <v-icon v-if="colvis">
                    visibility_off
                </v-icon>
                <v-icon v-else>
                    visibility
                </v-icon>
            </v-btn>
            <v-btn
                fab                
                small
                v-on:click="onDialogToggled()"
                >
                <v-icon>
                    add
                </v-icon>
            </v-btn>
            <v-text-field
                v-if="attributes.withsearch"
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                solo                
            ></v-text-field>
            </v-layout>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            v-model="result"
            :select-all="attributes.withcheck"
            item-key="id"     
            class='py-0 my-0'
        >
            <template slot="headers" slot-scope="props">
                <tr>
                    <th v-if="attributes.withcheck">
                        <v-checkbox
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.native="toggleAll"
                            
                        ></v-checkbox>
                    </th>
                    <th
                        v-for="header in props.headers"
                        :key="header.text"   
                        v-if="showHeader(header)"
                        class="text-left"
                    >                        
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template slot="items" slot-scope="props">
                <td v-if="attributes.withcheck">
                    <v-checkbox
                        v-model="props.selected"
                        primary
                        hide-details
                    ></v-checkbox>
                </td>
                <td>{{formatted(props.item.unitvalue)}}</td>
                <td>{{props.item.unit.name}}</td>
                
                <td v-if="colvis" class="lime darken-4">{{formatted(getForOnePerson(props.item))}}</td>
                <td v-if="colvis" class="lime darken-4">{{formatted(getForOnePersonWithLoss(props.item))}}</td>
                <td v-if="colvis" class="lime darken-4">{{formatted(getTargetAmount(props.item))}}</td>
                <td v-if="colvis" class="lime darken-4">{{formatted(getTargetAmountWithLoss(props.item))}}</td>
                
                
                <td v-if="props.item.ingredient">{{props.item.ingredient.name}}</td>
                <td v-if="props.item.ingredient.specification">
                    <span>{{ props.item.ingredient.specification.name}}</span>
                </td>
                <td v-else></td>
                    
                <td v-if="props.item.treatments.length">
                    <span v-for="treat in props.item.treatments">{{ treat.name}} |</span>
                </td>
                <td v-else></td>
                <td v-if="props.item.preparations.length">
                    <span v-for="prep in props.item.preparations">{{ prep.text}} |</span>
                </td>
                <td v-else></td>
                <td></td>
                <td class="justify-center">
                    <v-icon
                        small
                        class="mr-2"
                        v-on:click="editItem(props.item.id)"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      small
                      v-on:click="deleteItem(props.item.id)"
                    >
                      delete
                    </v-icon>
                  </td>
            </template>
            <v-alert v-if="attributes.withsearch" slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>            
        </v-data-table>        
        <formdatatabledialog 
                    :dialog="dialog"                     
                    :formdata="itemsformdata" 
                    :itemid="itemid"
                    v-on:dialogtoggled="onDialogToggled()"
                    >                        
        </formdatatabledialog>
    </v-card>
</template>


<script>
import formdatatabledialog from "./MainDialog.vue"
export default {
    components: {
        formdatatabledialog: formdatatabledialog
    },
    props:[
        'attributes',
        'vuexnamespace',            
    ],
    methods: {
        async editItem (item) {          
            
            this.itemid=item
            await this.$store.dispatch(this.itemsnamespace +'/getById',item)
            this.dialog = true
        },

        deleteItem (item) {
            
            this.itemid=item            
            confirm('Are you sure you want to delete this item?') && 
                        this.$store.dispatch(this.itemsnamespace +'/deleteById',{item_id:this.itemid, parent_id:this.parent_id})
            
        },
        
        onDialogToggled() {   
            //console.log(this.dialog)            
            this.dialog = !this.dialog
            this.itemid=undefined
            
        },
        calculateSum() {
            return this.items.map(i => i.unitvalue).reduce((acc,cur)=>Number(acc)+Number(cur),0)
        },
        getForOnePersonWithLoss(val) {
            return (100-val.cookingloss) * this.getForOnePerson(val)/100
        },
        getTargetAmountWithLoss(val) {
            return (100-val.cookingloss) * this.getTargetAmount(val)/100
        },
        getForOnePerson(val) {
            return (val.unitvalue*this.oneperson)/this.calculateSum()
        },
        getTargetAmount(val) {
            return this.getForOnePerson(val) * this.targetamount
        },
        formatted (val) {return Number(val).toFixed(this.decimals)},
        showHeader(header){return header.toggleable?this.colvis:true},
        
        
    },
   
    computed: {
        
        itemsnamespace (){return this.attributes.items.split('/')[0]},
        itemsformdata (){return this.$store.getters[this.itemsnamespace + '/formdata']},
        items () {return this.$store.getters[this.attributes.items]}, 
        rowsrc () {return this.$store.getters[this.itemsnamespace + '/dataobject']},        
        parent_id () {return this.$route.params.id},        
        canedit () {return typeof this.parent_id != "undefined"},
        result() {return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)},
        //test1(){return this.$store.getters['entities/entities']},                
    },
    
    data () {
        return { 
            oneperson:0,
            decimals:4,
            targetamount:0,   
            colvis:false,
            search: '',
            withsearch:false,
            withcheck:false,            
            dialog: false,
            formdatatabledialog: formdatatabledialog,            
            itemid:undefined,
            headers: [
                {
                    text: 'Menge',
                    value: 'unitvalue',
                    toggleable:false,
                    sortable:false
                },
                {
                    text: 'Einh',
                    value: 'unit',
                    toggleable:false,
                    sortable:false
                },
                {
                    text: '1/Por KW',
                    value: '',
                    toggleable:true,
                    sortable:false
                },
                {
                    text: '1/Por EW',
                    value: '',
                    toggleable:true,
                    sortable:false
                },
                
                {
                    text: 'Prod Gew',
                    value: '',
                    toggleable:true,
                    sortable:false
                },
                {
                    text: 'End Gew',
                    value: '',
                    toggleable:true,
                    sortable:false
                },
                
                {
                    text: 'Zutat',
                    value: 'ingredient',
                    toggleable:false,
                    sortable:false
                },
                {
                    text: 'Art',
                    value: 'ingredient.specification',
                    toggleable:false,
                    sortable:false
                },
                {
                    text: 'Verarbeitung',
                    value: 'treatment',
                    toggleable:false,
                    sortable:false
                },
                {
                    text: 'Zubereitung',
                    value: 'preparation',
                    toggleable:false,
                    sortable:false
                },
                
            ]
        }   
    },
    
    mounted() {           
        if(typeof this.parent_id != "undefined")
                this.$store.commit("recipesteps/RECIPESTEP_SET_FORRECIPE", this.parent_id)      
    }
    
}
</script>